import React from 'react';
import {
  Card,
  CardContent,
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export const DATE_RANGES = [
  { label: 'Ma', days: 1 },
  { label: '7 nap', days: 7 },
  { label: '30 nap', days: 30 },
  { label: '90 nap', days: 90 },
  { label: '1 év', days: 365 },
  { label: 'Egyéni', days: null },
];

const DateRangeSelector = ({
  selectedDays,
  setSelectedDays,
  isCustom,
  setIsCustom,
  customStart,
  setCustomStart,
  customEnd,
  setCustomEnd,
}) => {
  return (
    <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 3, mb: 3 }}>
      <CardContent sx={{ p: { xs: 2, md: 2.5 } }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
          <Typography variant="body2" fontWeight={600} color="text.secondary" sx={{ mr: 1 }}>
            Időszak:
          </Typography>
          <ToggleButtonGroup
            value={isCustom ? null : selectedDays}
            exclusive
            size="small"
            sx={{ flexWrap: 'wrap', gap: 0.5 }}
          >
            {DATE_RANGES.map((r) => (
              <ToggleButton
                key={r.label}
                value={r.days}
                onClick={() => {
                  if (r.days === null) {
                    setIsCustom(true);
                  } else {
                    setIsCustom(false);
                    setSelectedDays(r.days);
                  }
                }}
                selected={r.days === null ? isCustom : (!isCustom && selectedDays === r.days)}
                sx={{
                  borderRadius: '8px !important',
                  border: '1px solid !important',
                  px: 1.5,
                  fontSize: '0.8rem',
                  fontWeight: 500,
                  '&.Mui-selected': {
                    bgcolor: 'primary.main',
                    color: 'white',
                    borderColor: 'primary.main !important',
                    '&:hover': { bgcolor: 'primary.dark' },
                  },
                }}
              >
                {r.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          {isCustom && (
            <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
              <DatePicker
                label="Kezdő dátum"
                value={customStart}
                onChange={setCustomStart}
                slotProps={{ textField: { size: 'small', sx: { width: 160 } } }}
              />
              <Typography variant="body2" color="text.secondary">–</Typography>
              <DatePicker
                label="Záró dátum"
                value={customEnd}
                onChange={setCustomEnd}
                minDate={customStart}
                slotProps={{ textField: { size: 'small', sx: { width: 160 } } }}
              />
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default DateRangeSelector;
